<template>
  <v-dialog
    v-model="dialog"
    :loading="loading"
    width="800"
  >
    <template #activator="{ attrs, on }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        small
      >
        Brugere
      </v-btn>
    </template>

    <v-card>
      <v-toolbar flat>
        <v-toolbar-title>
          Rediger rollens brugere
        </v-toolbar-title>

        <v-chip class="ml-3" label small>
          {{ role.title }}
        </v-chip>

        <v-spacer />

        <v-menu
          v-model="addMenu"
          offset-y
          left
          :min-width="800"
          :close-on-content-click="false"
        >
          <template #activator="{ attrs, on }">
            <v-btn small v-bind="attrs" v-on="on">
              Tilføj bruger
              <v-icon right>
                mdi-plus
              </v-icon>
            </v-btn>
          </template>

          <v-card>
            <v-toolbar flat>
              <v-toolbar-title>
                Tilføj bruger
              </v-toolbar-title>
            </v-toolbar>

            <v-card-text>
              <v-autocomplete
                v-model="newRolePersonId"
                :items="selectableUsers"
                label="Vælg bruger"
                :loading="loadingUsers"
                outlined
                item-value="id"
                item-text="fullName"
                auto-select-first
              >
                <template #item="{ on, attrs, item }">
                  <v-list-item v-bind="attrs" v-on="on" :disabled="personCustomerRoles.map(x => x.personId).includes(item.id)">
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ item.fullName }}
                      </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-chip label small>
                        {{ item.title }}
                      </v-chip>
                    </v-list-item-action>
                  </v-list-item>
                </template>
                <template #selection="{ item }">
                  {{ item.fullName }}
                </template>
              </v-autocomplete>
            </v-card-text>

            <v-card-actions>
              <v-spacer />

              <v-btn
                :loading="creating"
                @click="add"
              >
                Tilføj
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
      </v-toolbar>
      <v-data-table
        :items="personCustomerRoles"
        :headers="headers"
        :loading="loading"
      >
        <template #[`item.validFrom`]="{ value }">
          {{ value | formatDateTime }}
        </template>
        <template #[`item.actions`]="{ item }">
          <v-btn small @click="remove(item.id)">
            <v-icon>
              mdi-delete-outline
            </v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
  </v-dialog>
</template>

<script>
import { stringify } from 'qs';

export default {
  name: 'PersonCustomerRoleComponent',
  props: {
    role: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      dialog: false,
      loading: false,
      loadingUsers: false,
      creating: false,
      deleting: false,
      personCustomerRoles: [],
      selectableUsers: [],
      addMenu: false,
      newRolePersonId: null,
      headers: [
        {
          text: 'Navn',
          value: 'personName'
        },
        {
          text: 'Titel',
          value: 'personTitle'
        },
        {
          text: 'Gyldig fra',
          value: 'validFrom',
          align: 'right',
          sortable: false
        },
        {
          text: 'Gyldig til',
          value: 'validTo',
          align: 'right',
          sortable: false
        },
        {
          text: 'Actions',
          value: 'actions',
          align: 'right'
        }
      ]
    }
  },
  watch: {
    dialog(value) {
      if (value) {
        this.getItems();
      }
    },
    addMenu(value) {
      if (value) {
        this.getUsers();
      }
    }
  },
  methods: {
    getItems: async function() {
      this.loading = true;

      try {
        const { data } = await this.$api.get('person-customer-roles', {
          params: {
            customerRoleId: this.role.id,
            isValid: true
          },
          paramsSerializer: params => {
            return stringify(params);
          }
        });

        this.personCustomerRoles = data;
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    getUsers: async function() {
      this.loadingUsers = true;

      try {
        const { data } = await this.$api.get('users', {
          params: {
            organizationKinds: [ 'internal' ]
          },
          paramsSerializer: params => {
            return stringify(params);
          }
        })

        this.selectableUsers = data;
      } catch (error) {
        this.$notifier.showError({});
      } finally {
        this.loadingUsers = false;
      }
    },
    add: async function() {
      this.creating = true;

      const model = {
        customerRoleId: this.role.id,
        personId: this.newRolePersonId
      };

      try {
        await this.$api.post('person-customer-roles', model);

        this.addMenu = false;
        this.newRolePersonId = null;
        this.getItems();
      } catch (error) {
        console.error(error);
      } finally {
        this.creating = false;
      }
    },
    remove: async function(id) {
      if (!confirm('Er du sikker?')) return;

      this.deleting = true;

      try {
        await this.$api.delete('person-customer-roles/' + id);

        this.getItems();
      } catch (error) {
        console.error(error);
      } finally {
        this.deleting = false;
      }
    }
  }
}
</script>